import {useLocation} from 'react-router-dom'
import style from './style.module.less'
import lazyLoading1 from '@/assets/images/lazyLoading/1.gif'
import lazyLoading2 from '@/assets/images/lazyLoading/2.gif'
import lazyLoading3 from '@/assets/images/lazyLoading/3.gif'

const LazyLoading = () => {
    const location = useLocation()
    return (
        <div className={style.wrap}>
            {
                location.pathname === '/center/fxsorder' ?
                    <img src={lazyLoading1} alt=''/> : location.pathname === '/center/xsorder' ?
                        <img src={lazyLoading2} alt=''/> : <img src={lazyLoading3} alt=''/>
            }
        </div>
    )
}

export default LazyLoading
